import { render, staticRenderFns } from "./packing.vue?vue&type=template&id=2b026318"
import script from "./packing.vue?vue&type=script&lang=ts"
export * from "./packing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports